module.exports = __webpack_public_path__ + "img/JULIANA F.1084a2b5.jpeg";